@for (crumb of crumbs(); track $index; let last = $last) {
    @if (crumb.route && !last) {
        <a [routerLink]="'/' + crumb.route">{{ crumb.name }}</a>
    } @else {
        <span [attr.aria-current]="last ? 'page' : null">{{ crumb.name }}</span>
    }
    @if (!last) {
        <span aria-hidden="true" class="sep">›</span>
    }
}
